module.exports = __webpack_public_path__ + "static/media/food.5baaccc4.svg";